//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BetslipLine',
  props: {
    selection: {},
    selectionLive: {},
    numSelections: {},
    freebet: {},
    mini: {},
    comboBoostIneligible: { type: Boolean, default: false },
    seguroCombinadaIneligible: { type: Boolean, default: false },
    seguroCombinadaMessage: { type: String, default: null }
  },
  data() {
    return {
      loading: true,
      balance: null
    }
  },
  filters: {
    format_odds(value, oddsFormat) {
      return _.get(value, 'display_odds.' + oddsFormat, parseFloat(value.odds).toFixed(2))
    }
  },
  computed: {
    is_each_way: {
      get() {
        return _.get(this.selection, 'outcome.is_each_way')
      },
      set(value) {
        this.$store.commit('betslip/setEachway', { key: _.get(this.selection, 'outcome.id'), value: value })
      }
    },
    stake: {
      get() {
        return _.get(this.$store.state.betslip, 'stakes.' + _.get(this.selection, 'outcome.id'))
      },
      set(value) {
        this.$store.commit('betslip/setStakes', { key: _.get(this.selection, 'outcome.id'), value: value })
      }
    },
    oddsChanged() {
      if (!this.selectionLive) return false
      return _.get(this.selection, 'outcome.odds') != _.get(this.selectionLive, 'odds')
    },
    betType() {
      return this.$store.state.betslip.betType
    },
    selections() {
      return this.$store.state.betslip.selections
    },
    selected() {
      let mySelections = _.map(this.$store.state.selections, 'outcome.id')
      return _.includes(mySelections, this.outcome.id)
    },

    // --- New computeds: consolidate template logic ---

    hasMultipleItems() {
      return !!_.get(this.selection, 'outcome.items')
    },
    itemNames() {
      return _.map(_.get(this.selection, 'outcome.items', []), (item) => this.$t(_.get(item, 'name')))
    },
    outcomeName() {
      const fullname = _.get(this.selection, 'outcome.fullname')
      return this.$t(fullname || _.get(this.selection, 'outcome.name'))
    },
    displayOdds() {
      const oddsFormat = _.get(this.$store.state, 'settings.oddsFormat')
      if (this.selectionLive && parseFloat(_.get(this.selectionLive, 'odds')) > 0) {
        return this.$options.filters.format_odds(this.selectionLive, oddsFormat)
      }
      if (_.get(this.selection, 'outcome.odds') > 0) {
        return this.$options.filters.format_odds(_.get(this.selection, 'outcome'), oddsFormat)
      }
      return null
    },
    oddsBadgeClass() {
      const live = this.selectionLive && parseFloat(_.get(this.selectionLive, 'odds')) > 0
      if (live) {
        return this.oddsChanged ? 'bg-primary text-white' : 'text-primary'
      }
      return 'border border-transparent text-primary'
    },
    showComboBoostIcon() {
      return !!(_.get(this.selectionLive, 'combo_boost_available') && this.betType === 'combi')
    },
    eventName() {
      return _.get(this.selection, 'event.name')
    },
    marketLine() {
      const marketName = this.$t(_.get(this.selection, 'market.name'))
      const outcomeLabel = _.get(this.selection, 'outcome.fullname') || _.get(this.selection, 'outcome.name')
      const marketType = _.get(this.selection, 'market.type')
      let line = marketName
      if (outcomeLabel) line += ` (${this.outcomeName})`
      if (marketType) line += ` ${this.$t(marketType)}`
      return line
    },
    isSuspended() {
      return !!_.get(this.selection, 'market.is_suspended')
    },
    formattedStartTime() {
      return this.$date(_.get(this.selection, 'event.starts_at')).format('MMM dd, H:mm')
    },
    showEachWay() {
      return this.betType === 'single' && _.get(this.selection, 'market.ew_place') > 1
    },
    ewPrice() {
      return _.get(this.selection, 'market.ew_price')
    },
    ewPlaces() {
      return _.get(this.selection, 'market.ew_place')
    },
    showStakeInput() {
      return (this.betType === 'single' && this.numSelections > 1) || (this.mini && this.betType === 'single' && this.numSelections === 1)
    }
  },
  mounted() {},
  methods: {
    changeEW() {},
    changeStake() {
      this.$store.commit('betslip/setStakeSingle', null)
    },
    remove(selection) {
      this.$store.commit('betslip/remove', {
        event: selection.event,
        market: selection.market,
        outcome: selection.outcome
      })
      this.$store.commit('betslip/setError', null)
      if (this.selections == 0) {
        this.$store.commit('betslip/toggleBetslip', false)
      }
    },
    addToSlip(event, market, outcome) {
      if (this.selected) {
        this.$store.commit('remove', { event: event, market: market, outcome: outcome })
      } else {
        this.$store.commit('add', { event: event, market: market, outcome: outcome })
      }
    }
  }
}
